import React from "react";

const WHY_CARDS = [
  { icon:"🏆", img:"https://images.unsplash.com/photo-1531498860502-7c67cf519b9e?w=400&q=80", title:"Trained & Certified Staff",  desc:"Every partner clears 6 quality filters before joining our team." },
  { icon:"📱", img:"https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&q=80", title:"Easy Booking",              desc:"Book your entire event in under 3 minutes — no complex procedures." },
  { icon:"💸", img:"https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=400&q=80", title:"Unbeatable Pricing",       desc:"Premium quality experiences starting at just ₹1,999. No hidden fees." },
  { icon:"🔒", img:"https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&q=80", title:"Safe & Secure",            desc:"Your data, payments and bookings are fully encrypted and protected." },
];

export default function WhyDarkSection() {
  return (
    <section className="cc-sec cc-sec-dark">
      <div className="container">
        <div className="text-center rv" style={{ marginBottom:56 }}>
          <h2 className="cc-h cc-h-white">Not Just Instant Delivery, <span className="gold">But..</span></h2>
        </div>
        <div className="row g-4">
          {WHY_CARDS.map((w, i) => (
            <div key={i} className={`col-md-6 rv d${i % 4 + 1}`}>
              <div className="why-dk-card">
                <img src={w.img} alt={w.title} className="why-dk-img" loading="lazy" />
                <div className="why-dk-body">
                  <div style={{ fontSize:24, marginBottom:8 }}>{w.icon}</div>
                  <div className="why-dk-title">{w.title}</div>
                  <div className="why-dk-desc">{w.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}